export default function InitWhishlist () {
	wishlistUpdateCount();
    jQuery( document ).on( 'added_to_wishlist removed_from_wishlist', wishlistUpdateCount );
    jQuery( '.woocommerce-wishlist' ).on('click', '.delete_item', function () {
        this.closest('.js-productbox').remove();
    })
}

function wishlistUpdateCount() {
    var counter = jQuery( '.header__wishlist-count' );

    jQuery.ajax({
        url: yith_wcwl_l10n.ajax_url,
        data: {
            action: 'yith_wcwl_update_wishlist_count'
        },
        dataType: 'json',
        success: function( data ) {
            counter.html( data.count );
            if ( 0 == data.count ) {
                counter.css( 'display', 'none' );
            } else {
                counter.css( 'display', 'flex' );
            }
        }
    });
};
